import { render, staticRenderFns } from "./SummaryEditCol.vue?vue&type=template&id=175d94ef"
import script from "./SummaryEditCol.vue?vue&type=script&lang=ts"
export * from "./SummaryEditCol.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports